import { render, staticRenderFns } from "./MemberAccountMergerComponent.vue?vue&type=template&id=621bf5ad&scoped=true&"
import script from "./MemberAccountMergerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberAccountMergerComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberAccountMergerComponent.vue?vue&type=style&index=0&id=621bf5ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621bf5ad",
  null
  
)

export default component.exports